import UIConfig from '@/UIConfig.ts';

export const inputStyle = {
  width: '100%',
  borderRadius: '14px',
  padding: '16px 18px',
  fontFamily: UIConfig.Fonts.Primary,
  outline: 'none',
  lineHeight: 1.5,
  fontSize: '15px',
  border: 'none',
  backgroundColor: '#FFFFFF',
  color: '#1A1A1A',
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.04)',
  letterSpacing: '-0.2px'
};
